export const getMarketsBreadcrumbs = () => ([
  {
    title: 'Market Overview',
  },
]);
